import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import type { Review } from "@/types";

export function useReviews(limit?: number) {
  const [reviews, setReviews] = useState<Review[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      let query = supabase
        .from("reviews")
        .select("*")
        .order("created_at", { ascending: false });
      if (limit) query = query.limit(limit);

      const { data, error: queryError } = await query;
      if (queryError) throw queryError;
      setReviews((data as Review[]) ?? []);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not load reviews right now.");
    } finally {
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => {
    load();
  }, [load]);

  return { reviews, loading, error, reload: load };
}